<template>
  <div class="interiorzone">
    <div class="toptit"><h2 class=" fl subheading">广告设置</h2><button @click="addadv()">增加广告</button><button @click="advertisinga()">H5 广告设置</button></div>
    <div class="contentbox">
      <ul class="advlist">
        <li class="listtit"><span>序列</span><span>属性</span><span>标题</span><span>类型</span><span>备注</span><span>权重</span><span>预览</span><span>操作</span></li>
        <li v-for="(item,index) in advlist" :key="index">
          <span>{{index+1}}</span>
          <span>[ {{item.scope|attribute}} ]</span>
          <span>{{item.adTile}}</span>
          <span>{{item.deviceName}}</span>
          <span>{{item.scopeDesc}}</span>
          <span>{{item.weight}}</span>
          <span><i class="iconfont icon-browse" @click="lookinfo(item)"></i></span>
          <span class="operation"><a href="javascript:void(0);" @click="toadrepair(item)">修改</a>|<a href="javascript:void(0);" @click="deladv(item.id)">删除</a></span>
        </li>
      </ul>
    </div>
    <div class="zzc"  v-if="islooksee">
      <div class="simulator">
        <div class="colosesee iconfont icon-close_icon" @click="colosesee"></div>
        <div class='top-nav-bar'><span class="nav-bar__title">{{simtit}}</span></div>
        <div class="articlecontent" v-html="msg"></div>
      </div>
    </div>
    <div class="zzc" v-if="advpanel">
      <div class="advsetpanel">
        <h2>广告语设置</h2>
        <div class="banksetbox">
          <el-input type="textarea" class="moreline" :rows="6"  placeholder="请输入内容" v-model="textarea"></el-input>
          <div class="bankinputbox  mgmgt">
              <el-radio v-model="adid" label="1" class="fl">应用于H5</el-radio>
              <el-radio v-model="adid" label="2" class="fl">应用于小程序</el-radio>
              <el-radio v-model="adid" label="3" class="fl">H5、小程序同步使用</el-radio>
          </div>
          <div class="savebox">
            <div class="tosave"  @click="setadv">保存</div>
            <div class="tocanel" @click="closeadv">取消</div>
          </div>
        </div>
      </div>
    </div>

    <!-- pagination -->
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="nowpage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagelist"
            :total=this.totalPage>
          </el-pagination>
        </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      nowpage:1,
      pagelist:10,
      advlist:[],
      advpanel:false,
      textarea:'',
      adid:1,
      islooksee:false,
      simtit:'',
      msg:'',
      totalPage:0,
    }
  },
  watch:{
    adid(val){
      if(this.interestpanel){
        if(this.adid=='1'){
          this.advertisinga()
        }
        else if(this.adid=='2'){
          this.advertisingb()
        }
      }
    }
  },
  mounted () {
    this.readadv()
  },
  methods: {
    handleCurrentChange(val) {
            this.nowpage = val;
            this.readadv();
    },
    readadv(){
      this.ajax.post('/advertising/advertisingList',{bizContent: {currentPage:this.nowpage,
      pageSize: this.pagelist}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.advlist=result.data.data.responseList
            this.totalPage = result.data.data.totalNum
          }
        }
      )
    },
    addadv(){
      this.$emit('refresh',new Date().getTime())
      this.$router.push('/bankacceptance/advertisements')
    },
    deladv(val){
      this.ajax.post('/advertising/delAdvertising',{bizContent:{id:val}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            swal({
              text: '删除成功！',
              timer: 2000,
              buttons: false
            })
            this.readadv()
          }
        }
      )
    },
    toadrepair(val){
      this.$emit('refresh',new Date().getTime())
      let a=val
      this.$router.push({name:'AdRepair',params:{advinfo:a}})
    },
    advertisinga(){
      this.advpanel=true;
      this.ajax.post(this.versatile.oaurl+'/system/getsystem',{bizContent: {name: 'advertising'}})
      .then(
        result=>{
          if(result.data.status=='0000' && JSON.stringify(result.data.data)!="{}"){
            if(result.data.data.value!=null){
              this.textarea=result.data.data.value
            }
          }
        }
      )
    },
    advertisingb(){
      this.advpanel=true;
      this.ajax.post(this.versatile.oaurl+'/system/getsystem',{bizContent: {name: 'miniprogram'}})
      .then(
        result=>{
          if(result.data.status=='0000' && JSON.stringify(result.data.data)!="{}"){
            if(result.data.data.value!=null){
              this.textarea=result.data.data.value
            }
          }
        }
      )
    },
    setadv(){
      if(this.adid==1){
        this.seth5()
      }
      else if(this.adid==2){
        this.setminiprogram()
      }
      else if(this.adid==3){
        this.seth5()
        this.setminiprogram()
      }
    },
    seth5(){
      this.ajax.post(this.versatile.oaurl+'/system/updatesystem',{bizContent:{name:"advertising",value:this.textarea}})
        .then(
          result=>{
            if(result.data.status=="0000"){
              swal({
                text: '提交成功',
                icon: "success",
                timer: 3000,
                buttons: false
              })
              this.advpanel=false
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
    },
    lookinfo(val){
      if(val.content!=''){
        this.msg=val.content
        this.simtit=val.adTile
        this.islooksee=true
      }
      else{
        this.$alert('当前为幻灯广告，无可预览内容', '系统提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
    },
    colosesee(){
      this.islooksee=false
    },
    setminiprogram(){
      this.ajax.post(this.versatile.oaurl+'/system/updatesystem',{bizContent:{name:"miniprogram",value:this.textarea}})
        .then(
          result=>{
            if(result.data.status=="0000"){
              swal({
                text: '提交成功',
                icon: "success",
                timer: 3000,
                buttons: false
              })
              this.advpanel=false
            }
            else{
              swal({
                text: result.data.message,
                timer: 3000,
                buttons: false
              })
            }
          }
        )
    },
    closeadv(){
      this.advpanel=false
    },
  }
}
</script>
<style scoped>
.toptit{
  width:100%;
  display:table;
  clear:both;
  margin-bottom:20px;
}
.toptit button{
  float:left;
  margin-left:30px;
  width:111px;
  height:39px;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 7px 0px rgba(61,143,226,0.43);
  border-radius:2px;
  color:#fff;
  margin-top:3px;
  cursor:pointer;
}
.toptit button.interest{
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 7px 0px rgba(61,143,226,0.43);
  border-radius:2px;
  border:1px solid rgba(61,143,226,1);
  color: #3D8FE2;
}
.advlist{
  width:96%;
  display: table;
  padding:2%;
  font-size: 14px;
}
.advlist li{
  clear: both;
  height:52px;
  line-height: 52px;
}
.advlist li span{
  display: block;
  float: left;
  height:52px;
  line-height: 52px;
  text-align: center;
  color: #222222;
}
.advlist li span:first-child{
 width:3%;
}
.advlist li span:nth-child(2){
 width:10%;
}
.advlist li span:nth-child(3){
 width:20%;
}
.advlist li span:nth-child(4){
 width:10%;
}
.advlist li span:nth-child(5){
 width:20%;
}
.advlist li span:nth-child(6){
 width:10%;
}
.advlist li span:nth-child(7){
 width:10%;
}
.advlist li span:nth-child(8){
 width:15%;
}
.advlist li:nth-child(odd){
  background: #fcfcfc;
}
.advlist li:nth-child(even){
  background: #fff;
}
.advlist li span > i{
  cursor: pointer;
}
.advlist li.listtit{
  background:rgba(252,252,252,1);
  border-radius:4px 4px 0px 0px;
  border-bottom:1px solid rgba(227,228,229,1)
}
.advlist li span.operation{
  color:#efefef;
}
.operation a{
  color:#222;
  margin:0 10px;
  text-decoration: none;
}
.operation a:hover{
  text-decoration: underline;
  color: #3D8FE2;
}
.advsetpanel{
  width:574px;
  min-height:400px;
  vertical-align: middle;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 14px 2px rgba(0,0,0,0.09);
  position: absolute;
  display: table;
  top: 50%;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 19;
  padding-bottom: 20px;
  margin-top:-300px;
}
.advsetpanel h2{
  width:574px;
  height:94px;
  line-height:94px;
  text-align:center;
  color:#fff;
  font-size:20px;
  background:rgba(61,143,226,1);
  margin-bottom:10px;
}
.banksetbox{
  width:428px;
  display:table;
  margin:0 auto;
}
.bankinputbox,.bankinputpanel{
  width:428px;
  height:87px;
  position: relative;
  clear: both;
  display: block;
}
.bankinputbox label,.bankinputbox input[type="text"],.bankinputpanel label,.bankinputpanel input{
  display:block;
  width:100%;
}
.bankinputbox label,.bankinputpanel label{
  margin-bottom:10px;
  width:160%;
  margin-top:10px;
  font-size:16px;
  color: #888;
}
.bankinputbox input[type="text"],.filterpanel{
  width:420px;
  padding-left:8px;
  font-size:18px;
  height:55px;
  line-height:55px;
  background-color:#F6F8FC;
}
.bankinputpanel input{
  padding-left:8px;
  font-size:18px;
  height:55px;
  line-height:55px;
  background-color:#F6F8FC;
}
.bankinputbox input[type="range"] {
  display:block;
  background-color: #3D8FE2;
  width:200px;
  height:5px;
  border-radius: 5px;
  margin:0 10px;
  -webkit-appearance:none;
}
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance:none;
  background-color: #49a9ee;
  width:20px;
  height:20px;
  border-radius: 50%;
  border:2px solid white;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
 input[type="range"]::-webkit-slider-thumb:hover {
  background-color: #fff;
  border:2px solid #49a9ee;
}
input[type="range"]::-webkit-slider-thumb:active {
  transform: scale(1.6);
}
.savebox{
  display: table;
  margin:0 auto;
  margin-top:38px;
  height:60px;
}
.savebox > div {
  width: 200px;
  height:60px;
  line-height: 60px;
  text-align: center;
  float: left;
  cursor: pointer;
}
.tosave{
  color: #fff;
  background:rgba(61,143,226,1);
  border:1px solid rgba(61,143,226,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  border-radius:2px;
  margin-right:20px;
}
.tosave:hover{
  background:rgb(54, 136, 218);
}
.tocanel{
  color: #3D8FE2;
  background-color: #f3f3f3;
  border:1px solid #efefef;
}
.tocanel:hover{
  background:#efefef;
}
.mgmgt{
  height:30px;
  margin-top:20px;
}
.bankinputbox label{
  width:auto !important;
  display: table;
}
.simulator{
  width:375px;
  height:667px;
  left:50%;
  top:50%;
  margin-left:-186px;
  margin-top: -333px;
  -webkit-box-shadow: #ebedf0 0 4px 12px;
  box-shadow: 0 4px 12px #ebedf0;
  background-color: #F2F2F2;
  position:absolute;
  font-family: -apple-system-font,BlinkMacSystemFont,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei UI","Microsoft YaHei",Arial,sans-serif;
}
.top-nav-bar {
  height: 64px;
  line-height: 64px;
  width:100%;
  position: relative;
  border-bottom: 1px solid 0.5px;
  background-color: #fff;
}
.nav-bar__title {
  width: 90%;
  margin: 0 auto;
  color: #323233;
  font-weight: 500;
  font-size: 15px;
  display: block;
  text-align: center;
  margin:0 5%;
  font-family: -apple-system-font,BlinkMacSystemFont,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei UI","Microsoft YaHei",Arial,sans-serif;
}
.nav-bar__back{
  position: absolute;
  left:5px;
  top:5px;
}
.articlecontent{
  width:335px;
  padding:20px;
  display: block;
  font-size: 16px;
  max-height: 560px;
  overflow: hidden;
  overflow-y: auto;
  font-family: -apple-system-font,BlinkMacSystemFont,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei UI","Microsoft YaHei",Arial,sans-serif;
}
.colosesee{
  position: absolute;
  right:-40px;
  top:10px;
  width: 32px;
  height:32px;
  color: #fff;
  font-size:28px;
  opacity: 0.5;
  cursor: pointer;
}
.colosesee:hover{
  opacity: 1;
  cursor: pointer;
}

.pagination{
  height: 111px;
  text-align: center;
  margin-top: 10px;
}
</style>




// WEBPACK FOOTER //
// src/page/bankacceptance/advlist.vue